module.exports = __webpack_public_path__ + "static/media/train-card4.ba6a5469.jpg";